
import serve from 'src/common/js/serve.js';

let http = serve.http;



// 登录
const loginFn = params => {
    return http.post(`${http.incCharge}/sys/login`, params).then(res => res.data);
};

// 获取菜单
const getMenuLists = params => {
    return http.get(`${http.incCharge}/sys/menu/nav`, {params: params}).then(res => res.data);
};

// 修改密码
const userPassword = params => {
    return http.post(`${http.incCharge}/sys/user/password`, params).then(res => res.data);
};

// 退出登录
const logout = params => {
    return http.post(`${http.incCharge}/sys/logout`, params).then(res => res.data);
};

// 根据运营商ID获取充电站列表
const getCompanyStations = params => {
    return http.get(`${http.incCharge}/resources/station/get-company-stations`, {params: params}).then(res => res.data);
};

// 获取省份
const getProviceListDIc = params => {
    return http.get(`${http.incCharge}/area/getProvinceListDic`, {params: params}).then(res => res.data);
};

export {
    loginFn,
    getMenuLists,
    userPassword,
    logout,
    getCompanyStations,
    getProviceListDIc
};


// WEBPACK FOOTER //
// ./src/api/common.api.js